import { useEffect, useRef, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";
import { DateSaisie } from "@/components/DateField";

export const ChoisirReservation = ({ onChoisir }) => {
  const [q, setQ] = useState("");
  const [logement, setLogement] = useState("");
  const [arrivee, setArrivee] = useState("");
  const [logements, setLogements] = useState([]);
  const [res, setRes] = useState(null);
  const [charge, setCharge] = useState(false);
  const boite = useRef(null);
  useEffect(() => { api.get("/logements").then((r) => setLogements(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (q.trim().length < 3 && !logement && !arrivee) { setRes(null); return undefined; }
    const t = setTimeout(() => {
      setCharge(true);
      api.get("/reservations/recherche", { params: { q: q.trim(), client: true, logement: logement || undefined, arrivee: arrivee || undefined } })
        .then((r) => setRes(r.data)).catch(() => setRes([])).finally(() => setCharge(false));
    }, 300);
    return () => clearTimeout(t);
  }, [q, logement, arrivee]);
  useEffect(() => {
    if (!res) { return undefined; }
    const dehors = (e) => { if (boite.current && !boite.current.contains(e.target)) { setRes(null); } };
    document.addEventListener("mousedown", dehors);
    return () => document.removeEventListener("mousedown", dehors);
  }, [res]);
  const choisir = (id) => { setRes(null); setQ(""); setLogement(""); setArrivee(""); onChoisir(id); };
  return (
    <div className="relative max-w-4xl" ref={boite} data-testid="calcul-choisir-reservation">
      <div className="flex flex-wrap gap-2">
        <div className="relative min-w-[260px] flex-1">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Choisir une réservation : numéro, client ou logement (3 caractères min.)"
            className="h-9 w-full rounded-md border border-slate-200 bg-white pl-9 pr-9 text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500" data-testid="calcul-choisir-input" />
          {charge && <Loader2 className="absolute right-3 top-2.5 h-4 w-4 animate-spin text-slate-400" />}
        </div>
        <select value={logement} onChange={(e) => setLogement(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid="calcul-choisir-logement">
          <option value="">Tous les logements</option>
          {logements.map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
        <label className="flex items-center gap-2 text-xs text-slate-600">Arrivée le
          <DateSaisie value={arrivee} onChange={setArrivee} title="Date d'arrivée" data-testid="calcul-choisir-arrivee" />
        </label>
      </div>
      {res && (
        <div className="absolute z-40 mt-1 w-full rounded-md border border-slate-200 bg-white shadow-lg" data-testid="calcul-choisir-resultats">
          {!res.length ? <p className="p-3 text-xs text-slate-500">Aucune réservation trouvée.</p> : res.map((r) => (
            <button key={r.id} type="button" onClick={() => choisir(r.id)} className="block w-full border-b border-slate-100 px-3 py-2 text-left last:border-0 hover:bg-emerald-50"
              data-testid={`calcul-choisir-${r.code}`}>
              <span className="font-mono text-sm font-semibold text-slate-900">{r.code}</span><span className="ml-2 text-xs text-slate-500">{r.plateforme}</span>
              <span className="block truncate text-xs text-slate-600">{r.nom_client || "—"} · {r.date_debut} → {r.date_fin} · {r.logement}</span>
            </button>
          ))}
          {res.length === 8 && <p className="px-3 py-1.5 text-[11px] text-slate-500" data-testid="calcul-choisir-plus">8 premiers résultats — précisez la recherche.</p>}
        </div>
      )}
    </div>
  );
};
